import { emptyObj } from '@beef/utils';
import { getFTTB } from './commonSelectors';

export const getFTTBTariff = (state) => getFTTB(state).tariff || emptyObj;
export const getFTTBTariffAdditionalParams = (state) => getFTTBTariff(state).additionalParams || emptyObj;
export const getFTTBTariffPrice = (state) => getFTTBTariff(state).price;
export const getFTTBTariffPreset = (state) => getFTTBTariff(state).preset || emptyObj;
export const getFTTBTariffPresetId = (state) => getFTTBTariffPreset(state).presetId;
export const getFTTBTariffPresetSplId = (state) => getFTTBTariffPreset(state).splId;
